export const getCommissionsByForm = (values) => {
    return {
        campaignCommission: values.campaignCommission ?? 20,
        restOfSiteCommission: values.restOfSiteCommission ?? 0,
        newCustomerCommission: values.newCustomerCommission ?? 0,
        coldCustomerCommission: values.coldCustomerCommission ?? 0,
        boostId: values.boostId ?? null
    };
};
